import React from "react";
import Header from "../components/Header/header";
import { AppShell } from "@mantine/core";
import { ToastContainer } from "react-toastify";

const Home = ({ page }) => {
  return (
    <>
      <AppShell
        padding="sm"
        header={<Header />}
        style={{ backgroundColor: "#ECECEC" }}
      >
        {page}
      </AppShell>
      <ToastContainer />
    </>
  );
};
export default Home;
